import { FC, useMemo } from 'react';
import { useField } from 'react-final-form';

import { FormDatePicker } from 'src/components/FormDatePicker/FormDatePicker';
import { getDateTime } from 'src/utils/getDateTime';

const maxDurationInDays = 14;

export const SearchFiltersFields: FC = () => {
  const {
    input: { value: from },
  } = useField<string | undefined>('from');

  const { min: minDate, max: maxDate } = useMemo(() => {
    const min = getDateTime({
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    });
    let max: Date | undefined = new Date();
    max.setDate(max.getDate() + maxDurationInDays);
    max = getDateTime({
      date: max,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    });

    return { min, max };
  }, []);

  return (
    <>
      <FormDatePicker
        label='Дата начала'
        name='from'
        dataTestId='from'
        fullWidth
        minDate={minDate}
        maxDate={maxDate}
      />
      <FormDatePicker
        label='Дата окончания'
        name='to'
        minDate={from || minDate.toISOString()}
        maxDate={maxDate.toISOString()}
        dataTestId='to'
        fullWidth
      />
    </>
  );
};
